import {z} from 'zod';

export enum AssetTaskName {
	IMPORTING = 'ImportingTask',
	VISUAL_DESCRIPTOR = 'VisualDescriptorTask',
	IMAGE_PROXIES = 'ImageProxiesTask',
	AUDIO = 'AudioTask',
	FFF_VIEW = 'FFFViewTask',
	INDD_PAGE = 'INDDPageTask',
	IWORK_PAGE = 'IWorkPageTask',
	KEYFRAMES = 'KeyframesTask',
	METADATA = 'MetadataTask',
	OFFICE_PAGE = 'OfficePageTask',
	PDF_PAGE = 'PDFPageTask',
	POST_IMPORT = 'PostImportTask',
	PREVIEW = 'PreviewTask',
	RELATED_ASSET = 'RelatedAssetTask',
	SWF = 'SWFTask',
	THUMBNAIL = 'ThumbnailTask',
	VIDEO_PREVIEW = 'VideoPreviewTask',
	WATERMARK = 'WatermarkTask',
	ZOOM = 'ZoomTask',
	ZOOM_TILE = 'ZoomTileTask',
}

export const assetTaskSchema = z.object({
	assetId: z.number().int().positive(),
	errorCode: z.number().int().positive(),
	errorMessage: z.string().nullable(),
	percentComplete: z.number().int().positive(),
	tasks: z.nativeEnum(AssetTaskName),
});

export type IAssetTask = z.infer<typeof assetTaskSchema>;
